import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ManagePost from 'modules/posts/components/ManagePost'

type NewPostPageProps = {
  isEvent?: boolean
}

const NewPostPage = ({ isEvent = false }: NewPostPageProps) => (
  <ResponsivePage.Body variant="full" showHeader={false}>
    <ManagePost isEvent={isEvent} />
  </ResponsivePage.Body>
)

export default NewPostPage
